import React from 'react';
import { Box,Stack,Typography } from '@mui/material';
import RafagaGrupoIcono from '../../components/RafagaGrupoIcono';
import BotonRafaga from './BotonRafaga';
export const gruposIniciales = [
  {clave:'principal',nombre:'Principal',padre:null,icono:'servicios'},
  {clave:'tramites',nombre:'Trámites',padre:null,icono:'negocio'},
];
export const claveGrupo = (a) => a.grupo_clave || (a.grupo==='TRAMITES' ? 'tramites' : 'principal');
export const agruparAccesos = (accesos,grupos=gruposIniciales) => {
  const items = (accesos || []).filter((a) => Number(a.activo));
  const propios = (g) => items.filter((a) => claveGrupo(a)===g.clave);
  return grupos.filter((g) => !g.padre).map((g) => ({...g,accesos:propios(g),
    hijos:grupos.filter((s) => s.padre===g.clave).map((s) => ({...s,accesos:propios(s)})).filter((s) => s.accesos.length),
  })).filter((g) => g.accesos.length || g.hijos.length);
};
export default function GruposRafaga({accesos,grupos,disabled,onAdd,onEdit}) {
  const buttons=(items) => <Box sx={{display:'grid',gridTemplateColumns:{xs:'repeat(2,minmax(0,1fr))',sm:'repeat(auto-fill,minmax(132px,1fr))'},gap:1.25,justifyItems:'start'}}>
    {items.map((a) => <BotonRafaga key={a.id_acceso || a.id_servicio} acceso={a} disabled={disabled} onAdd={onAdd} onEdit={onEdit} />)}
  </Box>;
  return <Stack spacing={3}>{agruparAccesos(accesos,grupos).map((g) => <Box component="section" key={g.clave} aria-label={g.nombre}>
    <Stack direction="row" spacing={1.25} alignItems="center" mb={1.5}>
      <RafagaGrupoIcono grupo={g} size={34} /><Typography fontSize={18} fontWeight={750}>{g.nombre}</Typography>
      <Box sx={{flex:1,height:'1px',bgcolor:'divider'}} />
    </Stack>
    {g.accesos.length>0 && buttons(g.accesos)}
    <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',xl:'repeat(2,minmax(0,1fr))'},gap:1.5,mt:g.accesos.length ? 2 : 0}}>{g.hijos.map((s) => <Box component="section" key={s.clave} aria-label={s.nombre}
      sx={{p:1.5,border:1,borderColor:'divider',borderRadius:2.5,minWidth:0}}>
      <Stack direction="row" spacing={1} alignItems="center" mb={1.5}><RafagaGrupoIcono grupo={s} size={30} />
        <Typography fontSize={14} fontWeight={750}>{s.nombre}</Typography></Stack>
      {buttons(s.accesos)}
    </Box>)}</Box>
  </Box>)}</Stack>;
}
